import { Type } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { useCallback } from 'react';

import type MessageTypes from '@/components/socket/SocketMessages';

import useChannelSubscription from './useChannelSubscription';

const CentrifugoEventSchema = Type.Object({
  event: Type.String(),
  data: Type.Optional(Type.Any()),
});

/** Wrapper for useChannelSubscription that filters events by a specific type */
const useChannelEventSubscription = (
  channel: string,
  event: MessageTypes,
  handler: (data: unknown) => void,
  options?: { enabled?: boolean },
) => {
  const channelHandler = useCallback(
    (data: unknown) => {
      // Confirm data is a valid object with an 'event' property
      if (!Value.Check(CentrifugoEventSchema, data)) {
        return;
      }

      const receivedEvent = data.event;

      if (receivedEvent === event) {
        if ('data' in data) {
          handler(data.data);
        } else {
          handler(null);
        }
      }
    },
    [event, handler],
  );

  useChannelSubscription(channel, channelHandler, { enabled: options?.enabled });
};

export default useChannelEventSubscription;
